/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createDrawBySystemGameId',
    message: messages.SUCCESS_CREATE_DRAW_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/draw/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_DRAW,
    requestSchema: requestSchemas.draws.createDrawBySystemGameId,
  },
  {
    action: 'getDrawById',
    message: messages.SUCCESS_GET_DRAW_BY_ID,
    method: 'GET',
    path: '/draw/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW,
    requestSchema: requestSchemas.draws.getDrawById,
  },
  {
    action: 'getDrawCustomers',
    message: messages.SUCCESS_GET_DRAW_CUSTOMERS,
    method: 'GET',
    path: '/draw/:drawId/customers',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_CUSTOMER,
    requestSchema: requestSchemas.draws.getDrawCustomers,
    scopes: [
      scopes.DEFAULT,
      scopes.DRAW_CUSTOMERS_INPUT,
    ],
  },
  {
    action: 'getDrawsBySystemGameId',
    message: messages.SUCCESS_GET_DRAWS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/draws/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW,
    requestSchema: requestSchemas.draws.getDrawsBySystemGameId,
    scopes: [
      scopes.DEFAULT,
      scopes.DRAWS_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DRAWS_OPEN_BY_SYSTEM_GAME_ID,
    ],
  },
];
